/**
 * Axios client functions.
 * @module Client
 *
 */

import axios from 'axios';

import config from 'config';
import { errorInterceptor } from 'core/services/utilities/request/helpers';

import { getAccessToken } from '../../auth';
import { getRequestId } from './get-request-id';

const {
  bff: { applicationID, baseUrl, clientID },
} = config;

export const axiosClient = axios.create({
  baseURL: baseUrl,
  headers: {
    Application: applicationID,
    client_id: clientID,
    'Content-Type': 'application/json',
    'session-id': getRequestId(),
  },
});

axiosClient.interceptors.request.use(
  (config) => {
    if (getAccessToken()) {
      config.headers.Authorization = `Bearer ${getAccessToken()}`;
    }

    return config;
  },
  (error) => {
    return errorInterceptor(error);
  },
);

axiosClient.interceptors.response.use((response) => response, errorInterceptor);
